import { Actor, Canvas, Random } from 'excalibur';
import { SEEDS } from '../utils/constants';
import { Palette } from '../utils/palette';
import { css, sketchStroke, wobblyCirclePath } from '../utils/sketch';

export class ClockHub extends Actor {
  private readonly hubCanvas: Canvas;

  constructor() {
    const canvas = new Canvas({
      width: 76,
      height: 76,
      cache: true,
      draw: (ctx) => paintHub(ctx),
    });
    super({
      name: 'clock-hub',
      graphic: canvas,
    });
    this.hubCanvas = canvas;
  }

  refreshTheme(): void {
    this.hubCanvas.flagDirty();
  }
}

function paintHub(ctx: CanvasRenderingContext2D): void {
  const rng = new Random(SEEDS.hub);
  const mid = 38;
  ctx.save();
  ctx.fillStyle = css(Palette.shadow, 0.12);
  wobblyCirclePath(ctx, mid + 2, mid + 3, 17, rng, 1.2, 22);
  ctx.fill();
  ctx.fillStyle = css(Palette.cream, 1);
  wobblyCirclePath(ctx, mid, mid, 16, rng, 1.2, 22);
  ctx.fill();
  ctx.restore();
  sketchStroke(ctx, rng, { color: Palette.ink, width: 3 }, (c) => wobblyCirclePath(c, mid, mid, 16, rng, 1.2, 22), 2, 0.8);
  ctx.save();
  ctx.fillStyle = css(Palette.inkSoft, 0.9);
  ctx.beginPath();
  ctx.arc(mid, mid, 3.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}
